import React, { CSSProperties, ReactNode } from 'react';
import AntdTypography from 'antd/lib/typography';
import { EllipsisConfig } from '../text';
import { extractDomProps } from '../../../utils/DomPropsExtractor';
import classnames from 'classnames';

/**
 * {@docCategory Paragraph}
 */
export interface ParagraphProps {
   /**
    * The id of the element
    */
   id?: string;

   /**
    * Content type
    */
   type?: 'secondary' | 'success' | 'warning' | 'danger';

   /**
    * Strikethrough style
    */
   strikethrough?: boolean;

   /**
    * Underline style
    */
   underline?: boolean;

   /**
    * Code style (e.g. for doing code blocks)
    */
   code?: boolean;

   /**
    * Keyboard style (e.g. for documenting key strokes)
    */
   keyboard?: boolean;

   /**
    * Mark style (e.g. highlighter)
    */
   mark?: boolean;

   /**
    * Bold style
    */
   strong?: boolean;

   /**
    * Disabled content
    */
   disabled?: boolean;

   /**
    * Display ellipsis when text overflows
    */
   ellipsis?: boolean | EllipsisConfig;

   /**
    * Sets a className
    */
   className?: string;

   /**
    * Sets styles
    */
   style?: CSSProperties;

   /**
    * The children
    */
   children?: ReactNode;

   /**
    * The theme
    */
   theme?: 'light' | 'dark';
}

export const Paragraph = (props: ParagraphProps) => {
   const classNames = classnames('uf-paragraph', {'uf-paragraph-dark': props.type === undefined && props.theme === 'dark'}, {'uf-paragraph-secondary-dark': props.type === 'secondary'  && props.theme === 'dark'}, props.className);
   return (
      <AntdTypography.Paragraph
         {...extractDomProps(props)}
         id={props.id}
         type={props.type}
         underline={props.underline}
         delete={props.strikethrough}
         code={props.code}
         keyboard={props.keyboard}
         mark={props.mark}
         strong={props.strong}
         disabled={props.disabled}
         ellipsis={props.ellipsis}
         className={classNames}
         style={props.style}
      >
         {props.children}
      </AntdTypography.Paragraph>
   );
};
